import { z } from "zod";
import { TenantSettingsSchema } from "./ai-features.js";

export const DeploymentModeSchema = z.enum(["iq_connected", "standalone"]);
export type DeploymentMode = z.infer<typeof DeploymentModeSchema>;

export const TenantStatusSchema = z.enum(["active", "suspended", "provisioning", "provisioning_failed"]);
export type TenantStatus = z.infer<typeof TenantStatusSchema>;

export const TenantSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1).max(255),
  slug: z.string().min(1).max(63).regex(/^[a-z0-9-]+$/),
  mode: DeploymentModeSchema,
  status: TenantStatusSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type Tenant = z.infer<typeof TenantSchema>;

export const ResourceLimitsSchema = z.object({
  maxUsers: z.number().int().positive().default(100),
  maxKnowledgeBaseSizeGb: z.number().positive().default(10),
  maxAgents: z.number().int().positive().default(20),
  maxMcpServers: z.number().int().nonnegative().default(5),
  maxConcurrentQueries: z.number().int().positive().default(10),
  dataRetentionDays: z.number().int().positive().default(365),
});
export type ResourceLimits = z.infer<typeof ResourceLimitsSchema>;

export const ComplianceProfileSchema = z.object({
  itar: z.boolean().default(false),
  cmmc: z.boolean().default(false),
  hipaa: z.boolean().default(false),
  gdpr: z.boolean().default(false),
  auditRetentionDays: z.number().int().positive().default(365),
});
export type ComplianceProfile = z.infer<typeof ComplianceProfileSchema>;

export const TenantConfigSchema = z.object({
  tenantId: z.string().uuid(),
  settings: TenantSettingsSchema,
  resourceLimits: ResourceLimitsSchema,
  complianceProfile: ComplianceProfileSchema,
  modelAccess: z.record(z.string(), z.boolean()).default({}),
  iqConnectionConfig: z
    .object({
      iqBaseUrl: z.string().url(),
      jwksUrl: z.string().url(),
      serviceTokenEndpoint: z.string().url().optional(),
    })
    .nullable()
    .default(null),
});
export type TenantConfig = z.infer<typeof TenantConfigSchema>;
